module.exports = __webpack_public_path__ + "static/media/bigflakes.ec6aa58d.webp";